var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mingxiMain_type === 1)?_c('guest',{attrs:{"pageType":3,"mingxi_type":_vm.mingxi_type,"mingxiMain_type":_vm.mingxiMain_type,"user_type":"2"}}):_vm._e(),(_vm.mingxiMain_type === 2)?_c('mendianList',{attrs:{"pageType":4,"mingxi_type":_vm.mingxi_type,"mingxiMain_type":_vm.mingxiMain_type,"caozuo_type":"1"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }